// frontend/lib/marketing-id.ts
export const COOKIE_NAME = "goi_fp_id";

export function getCookie(name: string) {
  return (
    document.cookie
      .split("; ")
      .find((r) => r.startsWith(name + "="))
      ?.split("=")[1] || null
  );
}

export function setCookie(name: string, value: string, days = 730) {
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; Path=/; Domain=.goifuneral.co.kr; Max-Age=${maxAge}; SameSite=Lax; Secure`;
}

export function initIdentity() {
  //   // 1. gid 복원
  //   const url = new URL(location.href);
  //   const gid = url.searchParams.get("gid");
  //   if (gid) {
  //     localStorage.setItem(COOKIE_NAME, gid);
  //     setCookie(COOKIE_NAME, gid);
  //     url.searchParams.delete("gid");
  //     history.replaceState(null, "", url.toString());
  //   }

  // 2. 쿠키 ↔ localStorage 자기치유
  let id = localStorage.getItem(COOKIE_NAME);
  const ck = getCookie(COOKIE_NAME);

  if (ck) {
    // 쿠키에 값이 있으면 로컬스토리지에 백업
    if (!id) {
      localStorage.setItem(COOKIE_NAME, ck);
    }
    id = ck; // 쿠키 값을 우선 사용
  } else if (id) {
    // 쿠키가 없고 로컬스토리지에만 있으면 쿠키 복원
    setCookie(COOKIE_NAME, id);
  } else {
    // 둘 다 없으면 새로 생성
    id =
      crypto.randomUUID?.() ||
      Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(COOKIE_NAME, id);
    setCookie(COOKIE_NAME, id);
  }

  return id;
}
